module.exports = __webpack_public_path__ + "static/preview-armand-3d0415e5f64e49364909132bf1a1e0db.wav";